let featuredJobsInstances = $('.featured-jobs-container');

if(featuredJobsInstances.length) {

    featuredJobsInstances.each(function() {

        let categoryId = $(this).data('job-category');

        if(!categoryId) return;

        $.post('/wp-admin/admin-ajax.php', {
            action: 'featured_jobs',
            category: categoryId,
        }, function(response) {
            if(response.success) {
                $(`#featured-jobs-container-${categoryId}`).html(response.data.data);
            }
        });

    });

}
